import * as React from 'react';

import TransactionMainGrid from '../../components/AmlTransactionsMain/TransactionMainGrid';

export default function Transaction(props) {
  return (
    <TransactionMainGrid />
  );
}
